"use client";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/src/store/store";
import { closeModal } from "@/src/store/slices/allModalSlice";
import { useRemoveCartItemMutation } from "@/src/store/rtkQueries/userPostAPI";
import { Button } from "@heroui/react";
import Loader from "@/src/ui/Loader";
import { TrashIconSVG } from "@/src/ui/AllSVG";
import { toast } from "@/src/lib/toast";

export default function RemoveCartItemModal() {
    const dispatch = useDispatch();
    const { data } = useSelector((state: RootState) => state.allCommonModal);
    const [removeCartItem, { isLoading }] = useRemoveCartItemMutation();

    const handleRemove = async () => {
        try {
            const response = await removeCartItem(data.cartItemId).unwrap();
            if (response.http_status_code === 200 || response.http_status_code === 201) {
                toast.success(response.message || 'Item removed from cart');
                dispatch(closeModal());
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div className="flex flex-col items-center gap-6 py-2 text-center">
                {isLoading && <Loader />}

                <div className="flex items-center justify-center w-14 h-14 rounded-full bg-red-50">
                    <TrashIconSVG />
                </div>

                <div className="space-y-1.5">
                    <h3 className="text-base font-semibold">Remove Item</h3>
                    <p className="text-sm text-body-color/60 max-w-xs">
                        Are you sure you want to remove{" "}
                        <span className="font-medium text-body-color">{data?.productName ?? "this item"}</span>{" "}
                        from your cart?
                    </p>
                </div>

                <div className="flex gap-3 w-full">
                    <Button
                        onPress={() => dispatch(closeModal())}
                        isDisabled={isLoading}
                        className="flex-1 border border-muted-color bg-transparent text-body-color text-sm font-medium rounded-full py-2.5"
                    >
                        Cancel
                    </Button>
                    <Button
                        onPress={handleRemove}
                        isDisabled={isLoading}
                        className="flex-1 bg-red-500 text-white text-sm font-medium rounded-full py-2.5"
                    >
                        Remove
                    </Button>
                </div>
            </div>
        </>
    );
}
